import Survey from "models/Survey";

export const SET = "surveyCheckWord/SET";
export const INIT = "surveyCheckWord/INIT";
export const CHANGE_LOCALE = "surveyCheckWord/CHANGE_LOCALE";

// 表示時データのセット
export const set = (
  survey,
  locales,
  questions,
  additionLocales,
  choices,
  freeCommentDescriptions
) => ({
  type: SET,
  survey: new Survey(survey),
  locales,
  questions,
  additionLocales,
  choices,
  freeCommentDescriptions
});

export const changeLocale = localeKey => ({
  type: CHANGE_LOCALE,
  localeKey
});

export const init = () => ({
  type: INIT
});

const initialState = {
  survey: new Survey(),
  selectedLocaleKey: null,
  locales: [],
  questions: [],
  additionLocales: [],
  choices: [],
  freeCommentDescriptions: []
};

const surveyCheckWord = (state = initialState, action) => {
  switch (action.type) {
    case SET: {
      const {
        survey,
        locales,
        questions,
        additionLocales,
        choices,
        freeCommentDescriptions
      } = action;

      // 選択している言語タブのlocaleKey。先頭の言語をデフォルトで設定
      const selectedLocaleKey = locales[0].key;

      return {
        survey,
        selectedLocaleKey,
        locales,
        questions,
        additionLocales,
        choices,
        freeCommentDescriptions
      };
    }

    case CHANGE_LOCALE: {
      const { localeKey } = action;

      return { ...state, selectedLocaleKey: localeKey };
    }

    case INIT: {
      return initialState;
    }

    default:
      return state;
  }
};

export default surveyCheckWord;



// WEBPACK FOOTER //
// ./src/redux/modules/surveyCheckWord.js